module.exports = __webpack_public_path__ + "img/112.f7af8248.jpg";